<div class="row pl-2" *ngIf="itinerary">
  <!-- #e9e9e9 -->
  <div class="col-12 content-detail-dark px-3 py-4"
  [ngStyle]="{'background-color': styleSidebar?.background_color }">
  <!-- <div class="col-12 content-detail-dark px-3 py-4"
  [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"> -->
    <div   class="d-flex mx-auto px-2 mb-3" style="gap: .35em;">
      <div *ngIf="permissionsMap['booking.itinerarios.editarfee']"
      class=" text-center position-relative d-flex justify-content-center w-100">

         <button class="btn btn-quote-summary d-flex justify-content-center align-items-center rounded"
                type="button"
                [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_1, 'color': buttonTextActive}"
                style="height: auto; min-height: 60px;width: 100%;"
                name="btn-liq"
                tooltip="Descargar cotización"
                placement="bottom"
                (click)="downloadItineraryQuote(itinerary.id, 'quote')">
                <img src="../../../assets/icons/itinerary-detail/COTIZACIÓN-01.svg" style="width: 40px;" alt="">
          <!-- <p class="mb-0 " [ngStyle]="{'color': styleSidebar?.color }">Cotización</p> -->
        </button>


      </div>

      <div
       *ngIf="permissionsMap['booking.itinerarios.editarfee']"
      class=" text-center position-relative d-flex justify-content-center w-100">

        <button class="btn btn-itinerary d-flex justify-content-center align-items-center rounded"
                type="button"
                               [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_1, 'color': buttonTextActive}"
                 style="height: auto; min-height: 60px;width: 100%;"
                name="btn-liq"
                tooltip="Descargar itinerario"
                placement="bottom"
                (click)="downloadItineraryQuote(itinerary.id, 'itinerary')">
                <img src="../../../assets/icons/itinerary-detail/ITINERARIO-01.svg" style="width: 40px;" alt="">

        </button>
      </div>

      <div *ngIf="permissionsMap['booking.itinerarios.editarfee']"
           class=" text-center position-relative d-flex justify-content-center w-100">

         <button
                  id="buttonSync"
                  class="btn  btn-actualizar d-flex justify-content-center align-items-center rounded "
                  style="height: auto; min-height: 60px;width: 100%;"
                [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_1, 'color': buttonTextActive}"
                  type="button"
                  title="{{timeLeft}}"
                  (click)="updateItinerary()"
                  [disabled]="!hasAvailableStatus() || sec"
                  name="btn-update"
                  tooltip="Verificar disponibilidad"
                  placement="bottom"
        >
        <img src="../../../assets/icons/itinerary-detail/BUSCAR_DISPONIBILIDAD-01.svg" style="width: 40px;" alt="">

        <!-- <p class="mb-0" [ngStyle]="{'color': styleSidebar?.color }" *ngIf="timeLeft === ''">Refrescar</p>
        <p class="mb-0 " [ngStyle]="{'color': styleSidebar?.color }" *ngIf="timeLeft > 0">Refrescando</p> -->
        </button>

        <span *ngIf="timeLeft > 0" [ngStyle]="{'color': styleSidebar?.color }" style="font-size:12px; position: absolute; bottom: -16px"> {{ timeLeft }} seg</span>
      </div>

      <div
       *ngIf="permissionsMap['booking.itinerarios.editarfee']"
      class=" text-center position-relative d-flex justify-content-center w-100">
        <button class="btn  btn-liquidacion d-flex justify-content-center align-items-center rounded "
                type="button"
                                [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_1, 'color': buttonTextActive}"
               style="height: auto; min-height: 60px;width: 100%;"
                name="btn-liq"
                tooltip="Descargar liquidación"
                placement="bottom"
                (click)="downloadLiquidation(itinerary.id);">
                <img src="../../../assets/icons/itinerary-detail/LIQUIDACÍON-01.svg" style="width: 45px;" alt="">
          <!-- <img #icon class="btn-i img-fluid" src="../../../assets/icons/itinerary-detail/liquidation.svg" alt=""> -->
          <!-- <p class="mb-0 " [ngStyle]="{'color': styleSidebar?.color }">Liquidación</p> -->
        </button>
      </div>
    </div>

    <div class="row px-4 mt-3">
      <div class="col-12 d-flex flex-column text-justify font-poppins f-11 py-3"
          style="border-top: 1px solid #bfbfbf"
          [ngStyle]="{'color': styleSidebar?.color }">
        <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0 font-medium">Última modificación:</p>
          <p class="mb-0 font-medium">{{getDateInOut(itinerary.updated_at)}}</p>
        </div >
          <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0 font-medium">Última actualización:</p>
          <p class="mb-0 font-medium">{{getDateInOut(currentDate)}}</p>
        </div>
      </div>
      <div class="col-12 text-center text-white" style="border-top: 1px solid #bfbfbf">
        <div class="row mt-3">
          <div class="col-6 d-flex align-items-center">
            <p class="font-poppins f-15 font-medium text-left text-price m-0 d-flex align-items-center" [ngStyle]="{'color': styleSidebar?.color }">Fee %
              <span class="d-flex">
                <label class="custom-radio-checkbox m-0">
                  <input class="custom-radio-checkbox__input" type="checkbox" [(ngModel)]="userService.activeGlobalFee"

                    [disabled]="((this.itinerary.status_id != 1 && this.itinerary.status_id != 2) || modifications)"
                    (click)="globalFeeClick($event)">
                  <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span>
                </label>
              </span>
            </p>
          </div>
          <div class="col-6 justify-content-end d-flex align-items-center">
            <input *ngIf="userService.activeGlobalFee" type="text" class="form-control font-poppins f-15"
            oninput="this.value = this.value.replace(/[^0-9]/g, ''); if(this.value > 99) this.value = 99;"
              [(ngModel)]="userService.globalFee" style="width: 100%; text-align: start;" pattern="/^[1-9]\d{6,10}$/"
              (input)="changeGlobalFee()" onkeypress='return event.charCode >= 48 && event.charCode <= 57'

              >
            <span class="font-poppins f-15 font-regular text-left text-price d-flex"
            [ngStyle]="{'color': styleSidebar?.color }"
              *ngIf="!userService.activeGlobalFee">{{ userService.priceRightFeePercentage | number : '1.2-2'}}%</span>
          </div>
        </div>

      </div>
    </div>

  </div>
  <!-- <div class="col-12 content-detail-dark px-3 py-4 mt-2"
  [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"> -->
  <div class="col-12 content-detail-dark px-3 py-4 mt-2"
  [ngStyle]="{'background-color': styleSidebar?.background_color }"
        >
    <div class="row px-4">
      <div class="col-12 text-center text-white">
        <div class="row justify-content-between px-3">
          <div class="d-flex align-items-center">
            <p class="font-poppins f-15  font-medium text-left text-price m-0" [ngStyle]="{'color': styleSidebar?.color }">Tarifa Neta</p>
          </div>
          <div class=" d-flex justify-content-end align-items-center">
            <a class="loader text-center justify-content-center" *ngIf="userService.totalPriceNotFee == -1">
              <i class="fas fa-spinner fa-spin"></i>
            </a>
            <ng-container *ngIf="taxSum === 0">
              <div class="d-flex">
                <p *ngIf="userService.totalPriceNotFee != 1 && userService.totalPriceYesFee != -1"
                   class="font-poppins  font-regular text-left m-0"
                   [ngStyle]="{
                    'color': styleSidebar?.color,
                    'font-size': (netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax) | dynamicFontSize: 15 : fontSizeAdjustments
                  }">
                   {{currencyAgency?.code}} {{(netPriceBooking > 0 ? netPriceBooking : netPriceBookingFreeTax) | number : '1.2-2'}}
                </p>
              </div>
            </ng-container>

            <!-- <ng-container *ngIf="netPriceBookingFreeTax  > 0">
              <p *ngIf="getOrigin == 'RENT-A-CAR'"
              class="font-poppins font-regular text-left m-0"
              [ngStyle]="{
                'color': styleSidebar?.color,
                'font-size': netPriceBookingFreeTax | dynamicFontSize: 15 : fontSizeAdjustments
              }">
                {{currencyItinerary}} {{ netPriceBookingFreeTax | number : '1.2-2'}}</p>
            </ng-container> -->

            <ng-container *ngIf="taxSum > 0">
              <div class="d-flex">
                <p *ngIf="userService.totalPriceNotFee != 1 && userService.totalPriceYesFee != -1"
                class="font-poppins font-regular text-left m-0"
                [ngStyle]="{
                  'color': styleSidebar?.color,
                  'font-size': (userService.totalPriceNotFeeAgency - taxSum)  | dynamicFontSize: 15 : fontSizeAdjustments
                }">
                  {{currencyAgency?.code}} {{netPriceBookingFreeTax  | number : '1.2-2'}}
                </p>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngIf="taxSum > 0" class="row mt-3 justify-content-between px-3">
            <div class="d-flex align-items-center">
              <p class="font-poppins f-15  font-medium text-left text-price m-0" [ngStyle]="{'color': styleSidebar?.color }">Cargos</p>
              <usb-tooltip-taxes-breakdown
                *ngIf="taxesSummable && taxesSummable.length > 0"
                class="ml-1"
                [taxes]="taxesSummable"
                [currency]="currencyAgency?.code"
                [clientsSettingAppBooking]="getClientsSettingAppBooking">
              </usb-tooltip-taxes-breakdown>

            </div>
            <div class="d-flex justify-content-end align-items-center">

            <div class="d-flex justify-content-end">
              <p *ngIf="userService.totalPriceNotFee != 1 && userService.totalPriceYesFee != -1"
              class="font-poppins font-regular text-left m-0"
              [ngStyle]="{
                'color': styleSidebar?.color,
                'font-size': taxSum | dynamicFontSize: 15 : fontSizeAdjustments
              }">
                  {{currencyAgency?.code}} {{ taxSum  | number : '1.2-2'}}</p>
            </div>
            </div>
        </div>
        <div class="row mt-3 justify-content-between px-3">
          <div class=" d-flex align-items-center">
            <p class="font-poppins f-15 font-medium text-left text-price m-0" [ngStyle]="{'color': styleSidebar?.color}">
            Fee
            </p>
          </div>
          <div class=" d-flex justify-content-end align-items-center">
            <div class="d-flex">
              <p class="font-poppins text-semiblack font-regular text-left m-0"
              [ngStyle]="{
                'color': styleSidebar?.color,
                'font-size': userService.priceRightFeeAgency | dynamicFontSize: 15 : fontSizeAdjustments
              }"
              >
              {{currencyAgency?.code}} {{userService.priceRightFeeAgency | number : '1.2-2'}}
            </p>
            </div>
          </div>
        </div>
        <div class="row mt-3 justify-content-between px-3 pt-3" style="border-top: 1px solid  #bfbfbf">
          <div class="d-flex align-items-center">
            <p class="font-poppins  f-15 font-medium text-left text-price m-0" [ngStyle]="{'color': styleSidebar?.color }">Total</p>
            <usb-tooltip-taxes-breakdown
              *ngIf="taxesNotSummable && taxesNotSummable.length > 0"
              class="ml-1"
              [taxes]="taxesNotSummable"
              [clientsSettingAppBooking]="getClientsSettingAppBooking">
            </usb-tooltip-taxes-breakdown>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <div class="d-flex">
               <a class="loader text-center justify-content-center" *ngIf="userService.totalPriceNotFee == -1">
                  <i class="fas fa-spinner fa-spin"></i>
               </a>

              <p *ngIf="userService.totalPriceYesFee != 1 && userService.totalPriceYesFee != -1"
              class="font-poppins text-semiblack font-regular text-left m-0"
              [ngStyle]="{
                'color': styleSidebar?.color,
                'font-size': userService.totalPriceYesFeeAgency | dynamicFontSize: 15 : fontSizeAdjustments
              }">
               {{currencyAgency?.code}} {{(userService.totalPriceYesFeeAgency + taxExcluded) | number : '1.2-2'}}
            </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- *ngIf="partialReserve"-->
  <ng-container *ngIf="showPartialContainer">
    <div class="col-12 content-detail-dark px-3 py-4 mt-2" *ngIf="userService.isActivePartial || validateProductsToPay()"  style="background-color: #f3f3f3;">
      <div class="px-4">
      <p class="text-left font-medium" style="font-family: 'Poppins';font-size: 19px; font-weight: 500; color: black">Reserva Parcial</p>
      </div>
      <div class="row px-4">
        <div class="col-12 text-center text-white">
          <div class="row">
            <div class="col d-flex align-items-center">
              <p class="font-poppins f-15 font-medium text-price text-nowrap text-left m-0" style="color: black">Tarifa <br> Reservar Neta</p>
            </div>
            <div class="col d-flex align-items-center justify-content-end">
              <a class="loader text-center justify-content-center" *ngIf="userService.totalPriceNotFeeByReserved == -1">
                <i class="fas fa-spinner fa-spin"></i>
              </a>

              <ng-container *ngIf="validateProductsToPay()">
                <div class="d-flex">
                  <p *ngIf="userService.totalPriceNotFeeByReserved != -1"
                  class="font-poppins font-regular text-left m-0" style="color: black"
                  [ngStyle]="{
                    'font-size':  userService.totalByReservedNotFeePartialAgency | dynamicFontSize: 15 : fontSizeAdjustments
                  }">
                     <!-- {{currencyItinerary}} {{ userService.totalPriceNotFeeByReserved | number : '1.2-2'}} -->
                      {{currencyAgency?.code}} {{userService.totalByReservedNotFeePartialAgency | number : '1.2-2'}}
                  </p>
                </div>
              </ng-container>

              <ng-container *ngIf="!validateProductsToPay()">
                <div class="d-flex">
                  <p class="font-poppins font-regular font-gray text-left m-0" style="color: black"
                  [ngStyle]="{
                    'font-size':  priceToPay | dynamicFontSize: 15 : fontSizeAdjustments
                  }">

                      {{currencyAgency?.code}} {{priceToPayAgency | number: '1.2-2'}}
                  </p>
                </div>
              </ng-container>

            </div>
          </div>

          <div class="row mt-3 pt-3" style="border-top: 1px solid #bfbfbf">
            <div class="col d-flex align-items-center">
              <p class="font-poppins f-15 font-medium text-left text-price m-0" style="color: black">Tarifa <br> Reservar</p>
            </div>
            <div class="col d-flex align-items-center justify-content-end">
              <a class="loader text-center justify-content-center" *ngIf="userService.totalPriceYesFeeByReserved == -1">
                <i class="fas fa-spinner fa-spin"></i>
              </a>
              <div class="d-flex">
                <p *ngIf="userService.totalPriceYesFeeByReserved != -1"
                class="font-poppins font-regular  text-left m-0"
                style="color: black"
                [ngStyle]="{
                  'font-size':  userService.totalByReservedYesFeePartialAgency | dynamicFontSize: 15 : fontSizeAdjustments
                }">
                   {{currencyAgency?.code}} {{ userService.totalByReservedYesFeePartialAgency | number : '1.2-2' }}
                </p>

              </div>
            </div>
          </div>

          <!-- <hr class="divider">
          <div class="row">
            <div class="col-12 text-right">
              <div class="row icon-premium-point">
                <div class="col px-4">
                  <ul class="nav justify-content-between w-100">
                    <li class="nav-item d-flex justify-content-start align-items-center">
                      <img src="../../../assets/img/app/little-icons/badge-bks.png" alt="logo bks" style="margin-right: 5px" />
                      <p class="font-point font-left f-16 m-0">Blickoins</p>
                    </li>
                    <li class="nav-item d-flex justify-content-end align-items-center">
                      <p class="font-point font-left m-0"
                      [ngStyle]="{
                        'font-size':  userService.totalPriceYesFeeByReserved | dynamicFontSize: 16 : fontSizeAdjustments
                      }">{{ itineraryService.parcialBlickoins ? (itineraryService.parcialBlickoins | number: '1.2-2') : 0 }} Bks.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </ng-container>
</div>
<ng-template #template>
  <form method="POST">
    <div class="modal-body text-center">
      <p>"This will save your current itinerary and start a new draft itinerary. Are you sure?"</p>
      <button type="button" data-placement="bottom" class="btn btn-sm btn-usblick" title="Yes" (click)="sendMail()">Yes</button>
      <button type="button" class="btn btn-outline-danger btn-sm" (click)="closeModal()">No</button>
    </div>
  </form>
</ng-template>
